// extracted by mini-css-extract-plugin
module.exports = {"button":"CluezCatalogDownloadButton_button__1EdkU"};